import React from 'react';
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { BrowserRouter } from 'react-router-dom'
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { FirebaseProvider } from 'contexts/FirebaseProvider'
import { APIProvider } from 'contexts/APIProvider'
import { AuthUserProvider } from 'contexts/AuthUserProvider'
import { SnackBarAlertProvider } from 'contexts/SnackBarAlertProvider'
import Router from 'routes/Router'
import theme from 'theme';
import { DialogProvider } from 'contexts/DialogProvider';
import { ChartJSProvider } from 'contexts/ChartJSProvider';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { LogRocketProvider } from 'contexts/LogRocketProvider';
import { MixpanelProvider } from 'contexts/MixpanelProvider';
import { ZendeskProvider } from 'contexts/ZendeskProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'

const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY || '');
const GTM_ID = process.env.REACT_APP_GTM_ID || ''

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      {/* <ErrorBoundary FallbackComponent={ErrorPage}> */}
      <BrowserRouter>
        <FirebaseProvider>
          <APIProvider>
            <Elements stripe={stripe}>
              <ChartJSProvider>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <GTMProvider state={{ id: GTM_ID }}>
                    <AuthUserProvider>
                      <SnackBarAlertProvider>
                        <DialogProvider>
                          <LogRocketProvider>
                            <MixpanelProvider>
                              <ZendeskProvider>
                                <Router></Router>
                              </ZendeskProvider>
                            </MixpanelProvider>
                          </LogRocketProvider>
                        </DialogProvider>
                      </SnackBarAlertProvider>
                    </AuthUserProvider>
                  </GTMProvider>
                </LocalizationProvider>
              </ChartJSProvider>
            </Elements>
          </APIProvider>
          </FirebaseProvider>
        </BrowserRouter>
        {/* </ErrorBoundary> */}
    </ThemeProvider>
  );
}

export default App;
